<template>
  <div class="col">
    <label for="selectEmployeeId" class="form-label">결제타입</label>
    <select
        class="form-control"
        v-model="selectedPayTypeIpt"
        @change="handleChange($event)"
    >
      <option
              v-for="type in typeList"
              :key="type.label"
              :value="type.value"
      >
        {{ type.label }}
      </option>
    </select>
  </div>
</template>

<script setup>
import {computed, defineProps, onMounted, ref} from "vue";
import tachoEntity from "@/entity/TachoEntity";
import store, {searchBarProps} from "@/store";

const emit = defineEmits(['change']);
const props = defineProps({
});

const typeList = [
  {label: "전체", value: null},
  ...Object.keys(tachoEntity.paymentTypeEnum)
      .filter((key) => {
        return [99, 1000].indexOf(parseInt(key, 10)) === -1;
      })
      .map((key) => {
        return {label: tachoEntity.paymentTypeEnum[key], value: key}
      }),
];
const selectedPayType = computed(() => store.state.searchBar.selectedPayType);
const selectedPayTypeIpt = ref(selectedPayType.value);
const patchSearchBar = (data) => store.dispatch('patchSearchBar', data);

function handleChange(evt) {
  let value = parseInt(evt.target.value, 10);
  if (isNaN(value)) {
    value = null;
  }

  patchSearchBar({
    prop: searchBarProps.selectedPayType,
    value,
  });
}

onMounted(() => {
});

</script>

<style scoped>
</style>
